<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Container, Radio, Stack, Text } from '@Shelly/shelly-design-system';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from 'src/helpers/interface_helpers';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Svelte hooks
	import { onMount } from 'svelte';

	export let device;

	const inputOptions = ['button', 'switch'];
	const _input_options_i18n = [$format('working_type_button'), $format('working_type_switch')];

	let inputsSettings = {};
	let id = real_id(device.id),
		settings = readDeviceSettings(id),
		loading = false,
		cache;

	const getSettings = () => {
		Object.keys(settings).forEach((setting) => {
			if (setting.includes('input:') && Number(setting.split(':')[1]) < 100) {
				inputsSettings[setting.split(':')[1]] = settings[setting].type;
			}
		});
		cache = Object.assign({}, inputsSettings);
	};
	const setTypeValue = async () => {
		const initialStateValue =
			settings[`${get_gen_2_component_channel_structure(device)}`].initial_state;
		let modeValue = settings[`${get_gen_2_component_channel_structure(device)}`].in_mode;
		const cacheMode = modeValue;
		// if (inputsSettings[0] === 'switch' && inputsSettings[1] !== 'switch') {
		// 	modeValue = 'dual_dim';
		// } else
		if (inputsSettings[0] === 'button') {
			modeValue = 'dim';
		} else if (inputsSettings[0] === 'switch') {
			modeValue = 'follow';
		}
		if (cacheMode !== modeValue) {
			const res_switch: SettingRequest = await gen2Request(
				device,
				`${get_gen_2_component_from_category(device)}.SetConfig`,
				{
					id: device.channel,
					config: { in_mode: modeValue, initial_state: initialStateValue },
				},
			);
			if (res_switch.isok) {
				settings[`${get_gen_2_component_channel_structure(device)}`].in_mode = modeValue;
				devices_settings.update_devices_settings(id, settings);
			}
		}
	};

	const sentRequest = async () => {
		let response;
		for (let inputChannel in inputsSettings) {
			if (cache[inputChannel] !== inputsSettings[inputChannel]) {
				loading = true;
				const res: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
					id: inputChannel,
					config: { type: inputsSettings[inputChannel] },
				});
				response = onSettingsResponse(res, device);
				setTypeValue();
				if (response.isok) {
					settings[`input:${inputChannel}`].type = inputsSettings[inputChannel];
					cache = { ...inputsSettings[inputChannel] };
					devices_settings.update_devices_settings(id, settings);
				}
			}
		}
		if (typeof response !== 'undefined' && response.isok) {
			if (
				inputsSettings[0] === 'button' &&
				settings[`${get_gen_2_component_channel_structure(device)}`].in_mode === 'dual_dim'
			) {
				inputsSettings[1] = 'button';
				const changeInput1: SettingRequest = await gen2Request(device, 'Input.SetConfig', {
					id: 1,
					config: { type: inputsSettings[1] },
				});
				if (changeInput1.isok) {
					settings[`input:1`].type = inputsSettings[1];
					cache = inputsSettings;
					devices_settings.update_devices_settings(id, settings);
				}
			}
		} else {
			inputsSettings = Object.assign({}, cache);
		}
		cache = Object.assign({}, inputsSettings);
		loading = false;
	};

	const setInputType = (option, index) => {
		inputsSettings[index] = option;
	};

	onMount(() => {
		getSettings();
	});
</script>

<Stack gap="s">
	{#each Object.keys(inputsSettings) as input, i}
		<Container padding="xs">
			<Text styleType="h2" class="mb-s">
				{$format('text_input_type_desc_per_id', {
					default: `Set type for device input ${inputsSettings[input] || i}:`,
					values: { index: settings[`input:${input}`]?.name || i },
				})}
			</Text>
			{#each inputOptions as option, index}
				<Radio
					size="m"
					selected={option}
					value={inputsSettings[i]}
					on:click={() => setInputType(option, i)}
					disabled={index === 1 &&
						i === 1 &&
						inputsSettings[0] === 'button' &&
						settings[`${get_gen_2_component_channel_structure(device)}`].in_mode ===
							'dual_dim'}
					id="radio-cq965vf"
				>
					{_input_options_i18n[index]}
				</Radio>
			{/each}
		</Container>
	{/each}
	<Button class="mt-s" {loading} size="m" width="full" on:click={() => sentRequest()}
		>{$format('button_save')}</Button
	>
</Stack>
